<template>
  <div>
    <div v-if="sendMessgeShow == 'list'" style="padding-top: 10px">
      <div class="flex_between mb20">
        <!-- <div class="flex">
          <el-button
            type="primary"
            class="el-icon-s-promotion"
            size="mini"
            @click="sendMessgeShow='send'"
          >发布消息</el-button>
          <el-button type="primary" size="mini" @click="selectType=2;getMessgeList()">我发布的</el-button>
          <el-button type="primary" size="mini" @click="selectType=1;getMessgeList()">已接收的</el-button>
        </div>-->
        <div class="flex">
          <el-input
            v-model="inputValue"
            onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"
            placeholder="请输入标题关键字"
            size="mini"
            @keyup.enter.native="getMessgeList"
          ></el-input>
          <el-button
            type="primary"
            class="ml10"
            size="mini"
            @click="getMessgeList"
            >搜索</el-button
          >
        </div>
      </div>
      <div style="background: #fff; padding-bottom: 20px">
        <el-table
          :data="tableData"
          style="width: 100%; min-height: 600px; margin-bottom: 10px"
          :row-style="{ height: '50px' }"
          center
          @row-click="rowClick"
        >
          <el-table-column prop="messageType" label="类型" width="180">
            <template slot-scope="scope">
              <el-tag :type="scope.row.messageCode">{{
                scope.row.messageType
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="messageTitle"
            label="标题"
            width="600"
          ></el-table-column>
          <el-table-column prop="sendName" label="发送人"></el-table-column>
          <el-table-column
            prop="sendTime"
            label="发送时间"
            sortable
            :sort-orders="['ascending', 'descending']"
          ></el-table-column>
        </el-table>
        <el-pagination
          :total="Pagetotal"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleIndexChange"
          class="paginations w_100s"
          :current-page="pageIndex"
        ></el-pagination>
        <div class="flex_jus_cen w_100s mt_20">
          <el-button plain @click="back" size="mini">返回</el-button>
        </div>
      </div>
    </div>
    <sendMessge
      v-if="sendMessgeShow == 'send'"
      @sendMessgeBack="sendMessgeBack"
    ></sendMessge>
    <lookMessge
      v-if="sendMessgeShow == 'look'"
      @returnList="returnList"
      ref="lookMessge"
    ></lookMessge>
  </div>
</template>

<script>
import lookMessge from "./lookMessge";
import sendMessge from "./sendMessge";
export default {
  name: "news",
  components: {
    sendMessge,
    lookMessge,
  },
  mounted() {},
  data() {
    return {
      Pagetotal: 0,
      pageSize: 20,
      pageIndex: 1,
      selectType: 1,
      sendMessgeShow: "list",
      inputValue: "",
      tableData: [],
      screenHeight: document.documentElement.clientHeight, //屏幕高度
    };
  },
  methods: {
    rowClick(data) {
      this.sendMessgeShow = "look";
      this.$nextTick(function () {
        this.$refs.lookMessge.getMessgeInfo(data);
      });
    },
    returnList() {
      this.sendMessgeShow = "list";
    },
    handleSizeChange(size) {
      // 切换每页显示的数量
      this.pageSize = size;
      this.getMessgeList();
    },
    handleIndexChange(current) {
      // 切换页码
      this.pageIndex = current;
      this.getMessgeList();
    },
    //返回
    back() {
      this.$emit("backshow", false);
    },
    sendMessgeBack() {
      this.sendMessgeShow = "list";
    },
    getMessgeList() {
      let data = {};
      data.messageTitle = this.inputValue;
      data.selectType = this.selectType;
      data.limit = this.pageSize;
      data.offset = (this.pageIndex - 1) * this.pageSize;
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.showList,
      //   data,
      //   false,
      //   true
      // ).then(res => {
      //   this.tableData = res.rows;
      //   this.Pagetotal = res.total;
      // });
    },
  },
  mounted() {
    this.getMessgeList();
  },
  watch: {
    sendMessgeShow(val) {
      if (val == "list") {
        this.getMessgeList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.paginations {
  /* position: absolute; */
  display: flex;
  flex-direction: row-reverse;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  margin-top: 0 !important;
  position: absolute;
  right: 30px;
}
.ml10 {
  margin-left: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.w_100s {
  width: 100%;
}
.mt_20 {
  margin-top: 40px;
}
.flex_between {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/index/new.vue